<template>
  <div class="card-box" style="min-height: 360px; overflow-y: auto; overflow-x: hidden">
    <div class="row">
      <div v-if="loadingFlag" class="w-100 d-flex justify-content-center align-items-center">
        <div class="spinner"></div>
      </div>

      <!-- Personal Info -->
      <h4 class="col-12 mb-2 text-uppercase bg-light p-2">
        <i class="mdi mdi-account-circle mr-1"></i> Personal Info
      </h4>

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="first-name">Account Name</label>
          <input
            id="first-name"
            v-model="BillingName"
            type="text"
            class="form-control bg-light"
            readonly
          />
        </div>
      </div>

      <div class="col-12 col-md-6"></div>

      <!-- <div class="col-12 col-md-4">
        <div class="form-group">
          <label for="first-name">First Name</label>
          <input
            id="first-name"
            v-model="firstName"
            type="text"
            class="form-control bg-light"
            readonly
          />
        </div>
      </div> -->

      <!-- <div class="col-12 col-md-4">
        <div class="form-group">
          <label for="last-name">Last Name</label>
          <input
            id="last-name"
            v-model="lastName"
            type="text"
            class="form-control bg-light"
            readonly
          />
        </div>
      </div>

      <div class="col-12 col-md-4">
        <div class="form-group">
          <label for="middle-name">Middle Name</label>
          <input
            id="middle-name"
            v-model="middleName"
            type="text"
            class="form-control bg-light"
            readonly
          />
        </div>
      </div>

      <div class="col-12">
        <div class="form-group">
          <label for="alter-name">Alternative Name</label>
          <input
            id="alter-name"
            v-model="alterName"
            type="text"
            class="form-control bg-light"
            readonly
          />
        </div>
      </div> -->

      <div class="col-12 col-md-6">
        <div class="form-group">
          <label for="user-email">e-Billing Address</label>
          <input
            id="user-email"
            v-model="userEmail"
            type="email"
            class="form-control bg-light"
            readonly
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reqUserAccountName } from '@services'

export default {
  data() {
    return {
      // firstName: null,
      // lastName: null,
      // middleName: null,
      // alterName: null,
      BillingName: null,
      userEmail: null,
      loadingFlag: false,
    }
  },

  watch: {
    '$store.state.auth.account_id': function(val) {
      if (val) {
        this.pageInit()
        this.loadingFlag = false
      }
    },
  },

  mounted() {
    if (this.$store.state.auth.account_id) {
      this.pageInit()
      this.loadingFlag = false
    }
  },

  methods: {
    async pageInit() {
      if (!this.$store.state.auth.account_id) {
        return
      }

      this.loadingFlag = true
      try {
        const resultAccountProfileName = await reqUserAccountName({
          account: this.$store.state.auth.account_id,
        })

        if (resultAccountProfileName.data) {
          // this.firstName = resultAccountProfileName.data.first_name
          // this.middleName = resultAccountProfileName.data.middle_name
          // this.lastName = resultAccountProfileName.data.last_name
          // this.alterName = resultAccountProfileName.data.alternative_name
          this.BillingName = resultAccountProfileName.data.billing_account_name
          this.userEmail = resultAccountProfileName.data.user_email
        }
      } catch (error) {
        console.error('Failed to fetch user account name:', error)
      } finally {
        this.loadingFlag = false
      }
    }
  },
}
</script>
